import { isDefined } from "@clipboard-health/util-ts";
import { Stack, type SxProps, type Theme } from "@mui/material";
import { formatCentsAsUsd } from "@src/appV2/lib/Money/utils/currency";
import { Text } from "@src/appV2/redesign/system/ui-components";

import { type findMatchingPayBreakdown } from "../../lib/estimatedPay";

interface ShiftPayRatesDisplayProps {
  isOffered: boolean;
  weekdayOffered: boolean;
  weekdayPayRate: ReturnType<typeof findMatchingPayBreakdown>;
  weekendOffered: boolean;
  weekendPayRate: ReturnType<typeof findMatchingPayBreakdown>;
  isWeekendAndWeekdayPayRateSame: boolean;
  shiftTypeLabel: string;
  sx?: SxProps<Theme>;
}

export function ShiftPayRatesDisplay(props: ShiftPayRatesDisplayProps) {
  const {
    isOffered,
    weekdayOffered,
    weekdayPayRate,
    weekendOffered,
    weekendPayRate,
    isWeekendAndWeekdayPayRateSame,
    shiftTypeLabel,
    sx,
  } = props;

  if (!isOffered) {
    return null;
  }

  return (
    <Stack
      spacing={3}
      flex="1 1 0%"
      pl={6}
      aria-label={`${shiftTypeLabel} shift pay rates`}
      sx={sx}
    >
      {isWeekendAndWeekdayPayRateSame && isDefined(weekdayPayRate) ? (
        <Text variant="body1" sx={{ fontWeight: 500 }}>
          {`${formatCentsAsUsd(weekdayPayRate.overallPay)} /hr`}
        </Text>
      ) : (
        <>
          {weekdayOffered && isDefined(weekdayPayRate) && (
            <Text variant="body1" sx={{ fontWeight: 500 }}>
              {`${formatCentsAsUsd(weekdayPayRate.overallPay)} /hr`}
            </Text>
          )}
          {weekendOffered && isDefined(weekendPayRate) && (
            <Text variant="body1" sx={{ fontWeight: 500 }}>
              {`${formatCentsAsUsd(weekendPayRate.overallPay)} /hr`}
            </Text>
          )}
        </>
      )}
    </Stack>
  );
}
